<template>
  <v-btn
    v-if="
      role(
        'admin',
        'departmentManager',
        'manager',
        'safetyRepresentative'
      )
    "
    @click="toggle"
    class="primary accent-4 white--text mr-2"
    small
  >
    <template v-if="state">
      <v-icon small left>account_tree</v-icon>
    </template>
    <template v-else>
      <v-icon small left>table_chart</v-icon>
    </template>
    {{
      state
        ? $t("profile.history.showTreeView")
        : $t("profile.history.showTable")
    }}
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["state"],
  computed: {
    ...mapGetters(["role"]),
  },
  methods: {
    toggle() {
      this.$emit("update:state", !this.state);
    },
  },
};
</script>
